/* global cookiePolicy */
import ApplicationController from "application_controller.js";

export default class extends ApplicationController  {
  debug = false;

  static targets = [ "withoutConsent", "withConsent", "content" ];
  static classes = [ "consented", "unconsented" ];
  static values = {
    category: { type: String, default: "necessary" },
    service: { type: String, default: "" },
    parentElement: { type: String, default: "" },
  };

  connect() {
    this.log_function("connect");

    this.findInformElement();

    this.render();
  }

  disconnect(){
    this.log_function("disconnect");
  }

  render(event){
    this.log_function("render");

    setTimeout(() => {
      if (this.isNecessary || this.acceptedService) {
        this.showContent();
      } else {
        this.hideContent();
      }
    }, 0);
  }

  showContent() {
    this.log_function("showContent");

    this.contentTarget.innerHTML = this.withConsentTarget.innerHTML;

    this.fix_scripts();
    this.fix_links();
    this.setInformElementClass(true);
  }

  consentContent() {
    this.dispatch("cookie-policy:consentEvent", {
      detail: {
        service: this.serviceValue,
        category: this.categoryValue,
      },
      prefix: false,
    });
  }

  hideContent() {
    this.log_function("hideContent");

    this.contentTarget.innerHTML = this.withoutConsentTarget.innerHTML;
    this.setInformElementClass(false);
  }

  //* Method to ensure scripts are run after being copied into dom
  //* Script tag inside the template won't automatically execute
  //* because the browser treats script tags inside template elements
  // * differently. Specifically, the scripts are inert, meaning they
  // * do not execute when they are simply moved into the DOM this way
  fix_scripts() {
    // Find all script tags within the target div
    const scripts = this.element.querySelectorAll("script");

    // If there are any script tags, reinsert them to execute
    scripts.forEach(oldScript => {
      const newScript = document.createElement("script");

      // Copy over all attributes from the old script tag
      Array.from(oldScript.attributes).forEach(attr => {
        newScript.setAttribute(attr.name, attr.value);
      });

      // Copy the inline script content, if any
      if (oldScript.innerHTML) {
        newScript.innerHTML = oldScript.innerHTML;
      }

      // Replace the old script with the new one in the DOM
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  fix_links() {
    // Find all script tags within the target div
    const links = this.element.querySelectorAll("link");

    // If there are any script tags, reinsert them to execute
    links.forEach(oldLink => {
      const newLink = document.createElement("link");

      // Copy over all attributes from the old script tag
      Array.from(oldLink.attributes).forEach(attr => {
        newLink.setAttribute(attr.name, attr.value);
      });

      // Copy the inline script content, if any
      /* istanbul ignore if -- a link is a void element, so its innerHTML is always empty */
      if (oldLink.innerHTML) {
        newLink.innerHTML = oldLink.innerHTML;
      }

      // Replace the old script with the new one in the DOM
      oldLink.parentNode.replaceChild(newLink, oldLink);
    });
  }

  findInformElement() {
    this.informElement = this.element;

    if(this.parentElementValue){
      this.informElement = this.element.closest(this.parentElementValue);
      if (!this.informElement) {
        this.log_error_function("connect", "could not find parent element");
      }
    }
  }

  setInformElementClass(consented){
    if(consented) {
      this.informElement.classList.add(this.consentedClass);
      this.informElement.classList.remove(this.unconsentedClass);
    } else {
      this.informElement.classList.add(this.unconsentedClass);
      this.informElement.classList.remove(this.consentedClass);
    }
  }

  get acceptedService() {
    return cookiePolicy.acceptedService(this.serviceValue, this.categoryValue);
  }

  get isNecessary() {
    return this.categoryValue === "necessary";
  }
}
